import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { mapState } from "vuex";
import menuMixin from "../mixin/menu";
import { createMenu } from "../libs/util.menu";
import BScroll from "better-scroll";
export default {
  name: "d2-layout-header-aside-menu-side",
  mixins: [menuMixin],
  render: function render(h) {
    var _this = this;
    return h("div", {
      "class": "d2-layout-header-aside-menu-side"
    }, [h("el-menu", {
      "attrs": {
        "collapse": this.asideCollapse,
        "collapseTransition": this.asideTransition,
        "uniqueOpened": true,
        "defaultActive": this.$route.fullPath
      },
      "ref": "menu",
      "on": {
        "select": this.handleMenuSelect
      }
    }, [this.aside.map(function (menu) {
      return createMenu.call(_this, h, menu);
    })]), this.aside.length === 0 && !this.asideCollapse ? h("div", {
      "class": "d2-layout-header-aside-menu-empty",
      "attrs": {
        "flex": "dir:top main:center cross:center"
      }
    }, [h("d2-icon", {
      "attrs": {
        "name": "inbox"
      }
    }), h("span", ["\u6CA1\u6709\u4FA7\u680F\u83DC\u5355"])]) : null]);
  },
  data: function data() {
    return {
      asideHeight: 300,
      BS: null,
      timer: null
    };
  },
  computed: _objectSpread({}, mapState("d2admin/menu", ["aside", "asideCollapse", "asideTransition"])),
  watch: {
    // 折叠和展开菜单的时候销毁 better scroll
    asideCollapse: function asideCollapse(val) {
      var _this2 = this;
      this.scrollDestroy();
      setTimeout(function () {
        _this2.scrollInit();
      }, 500);
    }
  },
  mounted: function mounted() {
    this.scrollInit();
    this.getBadgeStatus();
  },
  beforeDestroy: function beforeDestroy() {
    this.scrollDestroy();
    clearTimeout(this.timer);
  },
  methods: {
    getBadgeStatus: function getBadgeStatus() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, advisoryRes, badge, advisoryCount;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!_this3.timer) {
                _this3.timer = setTimeout(function () {
                  _this3.timer = null;
                  _this3.getBadgeStatus();
                }, 60000 * 2);
              }
              _context.n = 1;
              return _this3.$api.getBadgeStatus();
            case 1:
              res = _context.v;
              _context.n = 2;
              return _this3.$api.advisoryCount();
            case 2:
              advisoryRes = _context.v;
              // res.data.realNameCount = 1;
              // res.data.promote = true;
              // res.data.im = true;
              // res.data.complaint = true;
              // res.data.withdraw = true;
              // res.data.lifestyleCommentAuditCount = 1;
              // res.data.imKeywordRiskCount = 100;
              badge = res.data;
              advisoryCount = (advisoryRes === null || advisoryRes === void 0 ? void 0 : advisoryRes.data) || 0;
              _this3.aside.forEach(function (item) {
                if (item.title === "资金管理") {
                  if (badge.withdraw) {
                    _this3.$set(item, "badge", true);
                    item.children.forEach(function (second) {
                      if (second.title === "提现申请") {
                        badge.withdraw ? _this3.$set(second, "badge", true) : _this3.$set(second, "badge", false);
                      }
                    });
                  } else {
                    _this3.$set(item, "badge", false);
                  }
                }
                if (item.title === "品牌充值") {
                  if (badge.brandAuthProcessCount || badge.brandAuditHouseCount) {
                    _this3.$set(item, "badge", true);
                    item.children.forEach(function (second) {
                      if (second.title === "充值用户") {
                        badge.brandAuthProcessCount ? _this3.$set(second, "badge", badge.brandAuthProcessCount) : _this3.$set(second, "badge", false);
                      }
                      if (second.title === "充值审核") {
                        badge.brandAuditHouseCount ? _this3.$set(second, "badge", badge.brandAuditHouseCount) : _this3.$set(second, "badge", false);
                      }
                    });
                  } else {
                    _this3.$set(item, "badge", false);
                  }
                }
                if (item.title === "民宿管理") {
                  if (badge.bnbAuthProcessCount || badge.bnbAuditHouseCount) {
                    _this3.$set(item, "badge", true);
                    item.children.forEach(function (second) {
                      if (second.title === "民宿用户") {
                        badge.bnbAuthProcessCount ? _this3.$set(second, "badge", badge.bnbAuthProcessCount) : _this3.$set(second, "badge", false);
                      }
                      if (second.title === "民宿审核") {
                        badge.bnbAuditHouseCount ? _this3.$set(second, "badge", badge.bnbAuditHouseCount) : _this3.$set(second, "badge", false);
                      }
                    });
                  } else {
                    _this3.$set(item, "badge", false);
                  }
                }
                if (item.title === "品牌季度") {
                  if (badge.quarterAuditHouseCount) {
                    _this3.$set(item, "badge", true);
                    item.children.forEach(function (second) {
                      if (second.title === "季度审核") {
                        badge.quarterAuditHouseCount ? _this3.$set(second, "badge", badge.quarterAuditHouseCount) : _this3.$set(second, "badge", false);
                      }
                    });
                  } else {
                    _this3.$set(item, "badge", false);
                  }
                }
                if (item.title === "客户咨询") {
                  if (advisoryCount) {
                    _this3.$set(item, "badge", true);
                    item.children.forEach(function (second) {
                      if (second.title === "咨询列表") {
                        advisoryCount ? _this3.$set(second, "badge", advisoryCount) : _this3.$set(second, "badge", false);
                      }
                    });
                  } else {
                    _this3.$set(item, "badge", false);
                  }
                }
                if (item.title === "房源管理") {
                  if (badge.realNameCount || badge.houseAuthCount || badge.houseAuditCount) {
                    _this3.$set(item, "badge", true);
                    item.children.forEach(function (second) {
                      if (second.title === "房源审核") {
                        badge.houseAuditCount ? _this3.$set(second, "badge", badge.houseAuditCount) : _this3.$set(second, "badge", false);
                      }
                      if (second.title === "实名认证") {
                        badge.realNameCount ? _this3.$set(second, "badge", badge.realNameCount) : _this3.$set(second, "badge", false);
                      }
                      if (second.title === "认证列表") {
                        badge.houseAuthCount ? _this3.$set(second, "badge", badge.houseAuthCount) : _this3.$set(second, "badge", false);
                      }
                    });
                  } else {
                    _this3.$set(item, "badge", false);
                  }
                }
                if (item.title === "房源推广") {
                  if (badge.promote) {
                    _this3.$set(item, "badge", true);
                    item.children.forEach(function (second) {
                      if (second.title === "推广列表") {
                        badge.promote ? _this3.$set(second, "badge", true) : _this3.$set(second, "badge", false);
                      }
                    });
                  } else {
                    _this3.$set(item, "badge", false);
                  }
                }
                if (item.title === "Lifestyle") {
                  if (badge.subject || badge.lifestyleCommentAuditCount) {
                    _this3.$set(item, "badge", true);
                    item.children.forEach(function (second) {
                      if (second.title === "审核列表") {
                        badge.subject ? _this3.$set(second, "badge", true) : _this3.$set(second, "badge", false);
                      }
                      if (second.title === "评论审核") {
                        badge.lifestyleCommentAuditCount ? _this3.$set(second, "badge", true) : _this3.$set(second, "badge", false);
                      }
                    });
                  } else {
                    _this3.$set(item, "badge", false);
                  }
                }
                if (item.title === "社区管理") {
                  if (badge.communityCount || badge.communityCommentAuditCount) {
                    _this3.$set(item, "badge", true);
                    item.children.forEach(function (second) {
                      if (second.title === "社区审核") {
                        badge.communityCount ? _this3.$set(second, "badge", true) : _this3.$set(second, "badge", false);
                      }
                      if (second.title === "评论审核") {
                        badge.communityCommentAuditCount ? _this3.$set(second, "badge", true) : _this3.$set(second, "badge", false);
                      }
                    });
                  } else {
                    _this3.$set(item, "badge", false);
                  }
                }
                if (item.title === "唯心市集") {
                  if (badge.used || badge.usedCommentAuditCount) {
                    _this3.$set(item, "badge", true);
                    item.children.forEach(function (second) {
                      if (second.title === "审核列表") {
                        badge.used ? _this3.$set(second, "badge", true) : _this3.$set(second, "badge", false);
                      }
                      if (second.title === "评论列表") {
                        badge.usedCommentAuditCount ? _this3.$set(second, "badge", true) : _this3.$set(second, "badge", false);
                      }
                    });
                  } else {
                    _this3.$set(item, "badge", false);
                  }
                }
                if (item.title === "活动故事") {
                  if (badge.articleCommentAuditCount) {
                    _this3.$set(item, "badge", true);
                    item.children.forEach(function (second) {
                      if (second.title === "评论审核") {
                        badge.articleCommentAuditCount ? _this3.$set(second, "badge", true) : _this3.$set(second, "badge", false);
                      }
                    });
                  } else {
                    _this3.$set(item, "badge", false);
                  }
                }
                if (item.title === "IM管理") {
                  if (badge.im || badge.imKeywordRiskCount) {
                    _this3.$set(item, "badge", true);
                    item.children.forEach(function (second) {
                      if (second.title === "IM聊天") {
                        badge.im ? _this3.$set(second, "badge", true) : _this3.$set(second, "badge", false);
                      }
                      if (second.title === "IM监测") {
                        badge.imKeywordRiskCount ? _this3.$set(second, "badge", badge.imKeywordRiskCount) : _this3.$set(second, "badge", false);
                      }
                    });
                  } else {
                    _this3.$set(item, "badge", false);
                  }
                }
                if (item.title === "投诉管理") {
                  if (badge.complaint || badge.userOpinion || badge.quickComplaint) {
                    _this3.$set(item, "badge", true);
                    item.children.forEach(function (second) {
                      if (second.title === "投诉列表") {
                        badge.complaint ? _this3.$set(second, "badge", true) : _this3.$set(second, "badge", false);
                      }
                      if (second.title === "一键投诉") {
                        badge.quickComplaint ? _this3.$set(second, "badge", true) : _this3.$set(second, "badge", false);
                      }
                      if (second.title === "意见反馈") {
                        badge.userOpinion ? _this3.$set(second, "badge", true) : _this3.$set(second, "badge", false);
                      }
                    });
                  } else {
                    _this3.$set(item, "badge", false);
                  }
                }
                if (item.title === "用户管理") {
                  if (badge.userAuthCount || badge.memberCount) {
                    _this3.$set(item, "badge", true);
                    item.children.forEach(function (second) {
                      if (second.title === "强制实名") {
                        badge.userAuthCount ? _this3.$set(second, "badge", badge.userAuthCount) : _this3.$set(second, "badge", false);
                      }
                      if (second.title === "会员列表") {
                        badge.memberCount ? _this3.$set(second, "badge", badge.memberCount) : _this3.$set(second, "badge", false);
                      }
                    });
                  } else {
                    _this3.$set(item, "badge", false);
                  }
                }
                if (item.title === "运营管理") {
                  if (badge.businessCooperationCount) {
                    _this3.$set(item, "badge", true);
                    item.children.forEach(function (second) {
                      if (second.title === "商务合作") {
                        badge.businessCooperationCount ? _this3.$set(second, "badge", true) : _this3.$set(second, "badge", false);
                      }
                    });
                  } else {
                    _this3.$set(item, "badge", false);
                  }
                }
              });
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    scrollInit: function scrollInit() {
      this.BS = new BScroll(this.$el, {
        mouseWheel: true,
        click: true
        // 如果你愿意可以打开显示滚动条
        // scrollbar: {
        //   fade: true,
        //   interactive: false
        // }
      });
    },
    scrollDestroy: function scrollDestroy() {
      // https://github.com/d2-projects/d2-admin/issues/75
      try {
        this.BS.destroy();
      } catch (e) {
        delete this.BS;
        this.BS = null;
      }
    }
  }
};